module.exports = __webpack_public_path__ + "img/92506.9dbdbad8.jpg";